var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "d-flex tw-gap-0.5 list-unstyled text-gray-600" },
    [
      _vm.isThemeSfr
        ? _c(
            "a",
            {
              staticClass: "bg-gray-100",
              class: _vm.className,
              attrs: { href: _vm.hubHelper.getLink("sfrBeepiz") },
            },
            [
              _c("IconSfrdati", { staticClass: "size-8" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("hub.sfr")))]),
            ],
            1
          )
        : _vm.isThemeCatsafe
        ? _c(
            "a",
            {
              staticClass: "bg-gray-100",
              class: _vm.className,
              attrs: { href: _vm.hubHelper.getLink("catsafeBeepiz") },
            },
            [
              _c("IconCatsafe", { staticClass: "size-8" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("hub.catsafe")))]),
            ],
            1
          )
        : _c(
            "a",
            {
              staticClass: "bg-gray-100",
              class: _vm.className,
              attrs: { href: _vm.hubHelper.getLink("beepiz") },
            },
            [
              _c("IconBeepiz", { staticClass: "size-8" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("hub.beepiz")))]),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "a",
        { class: _vm.className, attrs: { href: _vm.managerUrl } },
        [
          _c("Icon", {
            staticClass: "size-8",
            attrs: { icon: "material-symbols:groups" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("hub.manager")))]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        { class: _vm.className, attrs: { href: _vm.supportUrl } },
        [
          _c("Icon", {
            staticClass: "size-8",
            attrs: { icon: "material-symbols:support" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("hub.support")))]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }